import React from "react";
import { Link } from "react-router-dom";

const TourDetailSummary = ({ selectedTour }) => {
  if (!selectedTour) {
    return <p>Không có thông tin tour.</p>;
  }

  return (
    <div className="card bg-light-200">
      <div className="card-body">
        <h5 className="d-flex align-items-center fs-18 mb-3">
          <span className="avatar avatar-md rounded-circle bg-primary me-2">
            <i className="isax isax-signpost5"></i>
          </span>
          {selectedTour.tourName}
        </h5>
        <div>
          <div className="d-flex align-items-center justify-content-between details-info">
            <h6 className="fw-medium">Danh mục: </h6>
            <p className="flex-fill">
              <Link to={`/category/${selectedTour.categoryId}`}>
                {selectedTour.category?.categoryName}
              </Link>
            </p>
          </div>
          <div className="d-flex align-items-center justify-content-between details-info">
            <h6 className="fw-medium">Thời gian: </h6>
            <p className="flex-fill">
              {selectedTour.numberDay} ngày {selectedTour.numberDay - 1} đêm
            </p>
          </div>
          <div className="d-flex align-items-center justify-content-between details-info">
            <h6 className="fw-medium">Giá: </h6>
            <p className="flex-fill">
              {new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND",
              }).format(selectedTour.price)}
            </p>
          </div>

          <div className="d-flex align-items-center justify-content-between details-info">
            <h6 className="fw-medium">Số du khách / tour: </h6>
            <p className="flex-fill">{selectedTour.maxParticipants} du khách</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourDetailSummary;
